module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, jQuery) {
	"use strict";

	fox.registerWidget('UserOfferAcp', {
		_acpAuthUrl: '/api.php?_method=Offer_Acp.RedirectAuth&redirect=1&alias=',
		_menuItemTemplate: 'main_menu_item_freeAcpAuth',

		configure: function (options) {
			this._acpAuthUrl += this.alias;
			this.menuPattern = {
				title: 'Bonus videos',
				url: this._acpAuthUrl,
				target: '_blank',
				position: 4.5 // add item after tab "Videos",
			};
			if (fox.checkTemplate(this._menuItemTemplate)) {
				this.menuPattern.template = this._menuItemTemplate;
			}

			this.registerOptions('', {
				widgets: {
					preCancelOverlay: {
						widget: 'Widget',
						autoRender: false,
						embed: {
							widget: '@root',
							location: 'lastChild',
							container: 'body'
						},
						template: options.offerSettings.widget.template || 'offer_overlay_freeacp_precancel',
						templateOptions: options.offerSettings.widget.templateOptions || {},

						handleDom: {
							confirmPreCancelOffer: {
								target: '.submit-btn',
								event: 'click',
								callback: fox.bind(this.confirmPreCancelOffer, this)
							},
							declinePreCancelOffer: {
								target: '.cancellation-exit',
								event: 'click',
								callback: fox.bind(this.declinePreCancelOffer, this)
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		prepare: function () {
			this.callParent('prepare', arguments);
			this.preCancelOverlay = this.rwom1('#preCancelOverlay');

			var apiAddress = this.getAction('confirmPreCancel');
			this.preCancelOverlay.setTemplateOptions('confirmApiAddress', apiAddress.address);
			this.preCancelOverlay.render();
		},

		actionPreCancel: function () {
			if (fox.site.member.getObjectValue('manual')) {
				// don't show offer to manual user
				return false;
			}

			var offerState = this._offer.get('userOffer.state');
			if (offerState === this.const.STATE_ACTIVE) {
				//TODO: we have no design for this
				return false;//this.showCancelAlert();
			}

			if (offerState === false || offerState !== this.const.STATE_ACTIVE) {
				this.updateState('new');
				this.log('UserOfferAcp shows offer popup', {
					section: 'UserOfferAcp',
					action: 'actionPreCancel'
				});
				this.showOverlay();
			}
		},

		actionUserCanceled: function () {
			this.updateState('suspended');
			this.removeAuthLink();
		},

		actionUserRenewed: function () {
			this.reload(fox.bind(function (data, w, e) {
				if (e === 'ready' && this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
					this.addAuthLink();
				}
			}, this));
		},

		actionTrialToFull: function () {//TODO
			if (this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
				// do not show offer if it's already active
				return false;
			}
			// check if user is trial then show popup or add menu
		},

		actionOffersPrepared: function () {
			if (this._offer.get('userOffer.state') === this.const.STATE_ACTIVE) {
				this.addAuthLink();

				return true;
			}

			// if (this._offer.get('userOffer.context.trialDeclined')) {//TODO: if offer was declined then add menu item without popup. did not checked!
			// 	this.addOfferToMenu();
			// 	return true;
			// }
		},

		showCancelAlert: function () {//TODO
			// if offer is active show alert message, else offer will be prompted
			// this.rwom1('#cancelWarningPopup').show();
		},

		confirmPreCancelOffer: function () {
			this.updateState('confirmed', true);
			this.updateState('active', true);
			this.hideOverlay();

			this.addAuthLink();

			fox.site.gotoPage('home');

			return true;
			/*this.sendAction('confirmPreCancel', {}, fox.bind(function (data, w, e) {
				document.location.href = this._acpAuthUrl;
				return true;
				if (e === 'failure') {//TODO
					console.log('UserOfferAcp: something wrong', data);
				}

				this.updateState('active', false);
				this.hideOverlay();

				this.addAuthLink();

				fox.site.gotoPage('home');
				this.openAuthLink();
			}, this));*/
		},

		declinePreCancelOffer: function () {
			// this.updateState('declined'); // we don't need to decline offer for this type, 'cause we will ask user each time when he wants make cancel
			this.log('UserOfferAcp offer declined by user', {
				section: 'UserOfferAcp',
				action: 'declinePreCancelOffer'
			});
			this.hideOverlay();
		},

		declineTrialOffer: function () {//TODO
			this.updateContext({trialDeclined: true});//or something like that

			this.addOfferToMenu();
		},

		declineExistsOffer: function () {//TODO
			// update offer if need
			this.rwom1('#cancelWarningPopup').hide();
		},

		saveExistsOffer: function () {//TODO
			this.rwom1('#cancelWarningPopup').hide();
			fox.site.gotoPage('home');
		},

		openAuthLink: function () {
			// window.open(this._acpAuthUrl, '_blank');
		},

		addAuthLink: function() {
			fox.setEnv('offer.freeAcpAuth.url', this._acpAuthUrl);
			var menuControllers = fox.wom.select('~.Menu_Main');//there is 2 menu controllers. 1st for desktop, 2nd for mobile
			fox.each(menuControllers, function (menuCtrl) {
				menuCtrl.addMenuItem('freeAcpAuth', this.menuPattern);
				// add on click action!
				// icon added as class: <i class="ico icon-au_m_$[alias]"></i>
			}, this);
		},

		removeAuthLink: function() {
			var menuControllers = fox.wom.select('~.Menu_Main');//there is 2 menu controllers. 1st for desktop, 2nd for mobile
			fox.each(menuControllers, function (menuCtrl) {
				menuCtrl.dropMenuItem('freeAcpAuth');
			}, this);
		},

		addOfferToMenu: function() {
			console.log('UserOfferAcp: add offer to menu');
		},

		showOverlay: function() {
			if (!this.preCancelOverlay.element) {
				this.handleEvent(this.preCancelOverlay, 'addedToDom', fox.bind(this.showOverlay, this));
				return false;
			}
			jQuery(this.preCancelOverlay.element).show();
			jQuery('html').css('overflow', 'hidden');
		},

		hideOverlay: function() {
			jQuery(this.preCancelOverlay.element).hide();
			jQuery('html').css('overflow', '');
		}
	}, 'UserOfferBase');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/offer/controllers/UserOfferAcp.js
// module id = 127
// module chunks = 4